import { CalendarDate } from '@internationalized/date';
import { UsageMetricsSortOption } from '@rematter/frontend-lib-api-client';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { QueryAtomResult } from '~/shared/providers/api/createQueryAtomFactory';

export type UsageMetricsRecord = QueryAtomResult<
  typeof systemUsageMetricsQueryAtom
>['entries'][number];

export const systemUsageMetricsQueryAtom = createQueryAtomFactory(
  'admin.systemUsageMetrics',
  (params: {
    filter?: {
      organizationIds?: string[];
      modelProvider?: string;
      model?: string;
      dateFrom?: CalendarDate;
      dateTo?: CalendarDate;
    };
    sorting?: UsageMetricsSortOption[];
    pagination?: {
      limit: number;
      offset: number;
    };
  }) => ({
    assistantSystemUsageMetrics: {
      __args: {
        filter: {
          ...params.filter,
          dateFrom: params.filter?.dateFrom?.toString(),
          dateTo: params.filter?.dateTo?.toString(),
        },
        sorting: params.sorting,
        pagination: params.pagination,
      },
      entries: {
        organization: {
          id: true,
          name: true,
        },
        modelProvider: true,
        model: true,
        totalInputTokens: true,
        totalReasoningTokens: true,
        totalCacheReadTokens: true,
        totalOutputTokens: true,
        totalTokens: true,
        totalCost: {
          amount: true,
          currencyCode: true,
        },
        recordCount: true,
        periodStart: true,
        periodEnd: true,
      },
      page: {
        offset: true,
        limit: true,
        total: true,
      },
    },
  }),
  {
    select: ({ assistantSystemUsageMetrics }) => ({
      total: assistantSystemUsageMetrics.page.total ?? 0,
      entries: assistantSystemUsageMetrics.entries.map((e) => ({
        ...e,
        id: `${e.organization.id}:${e.modelProvider}:${e.model}`,
      })),
      page: assistantSystemUsageMetrics.page,
    }),
  },
);
